import { Form, Input, Modal, message } from "antd";
import { formatError } from "common/redux/middleware/queryErrorLogger";
import {
  useCreateCommunicationResultItemMutation,
  useUpdateCommunicationResultItemMutation,
} from "features/communicationResultItems/communicationResultItemsAPI";
import styled from "styled-components";

const StyledForm = styled(Form)`
  margin-top: 12px;
  max-width: 400px;
`;

export default function CommunicationResultItemModal({
  title,
  onOk,
  onCancel,
  resultItem,
  resultType,
}) {
  const [form] = Form.useForm();
  const [createCommunicationResultItem] = useCreateCommunicationResultItemMutation();
  const [updateCommunicationResultItem] = useUpdateCommunicationResultItemMutation();

  const isEditing = !!resultItem;

  const initialValues = isEditing
    ? {
        id: resultItem.id,
        name: resultItem.name,
        notes: resultItem.notes,
      }
    : {};

  const onSubmit = async () => {
    const formData = await form.validateFields();

    let result;
    if (isEditing) {
      result = await updateCommunicationResultItem({
        id: resultItem.id,
        name: formData.name,
        notes: formData.notes,
      });
    } else {
      result = await createCommunicationResultItem({
        resultType,
        name: formData.name,
        notes: formData.notes,
      });
    }

    if ("data" in result) {
      const successMessage = isEditing
        ? "Communication result updated successfully."
        : "Communication result created successfully.";
      message.success(successMessage);
      onOk();
      form.resetFields();
    }
    if ("error" in result) {
      form.setFields(formatError(result.error));
    }
  };

  return (
    <Modal
      maskClosable={false}
      title={title}
      open
      okText="Submit"
      onOk={onSubmit}
      onCancel={onCancel}
    >
      <StyledForm
        form={form}
        layout="vertical"
        labelAlign="left"
        initialValues={initialValues}
        validateMessages={{ required: "This is a required field" }}
      >
        <Form.Item name="name" label="Name" rules={[{ required: true }]}>
          <Input placeholder="e.g., My Custom Result" />
        </Form.Item>
        <Form.Item name="notes" label="Notes">
          <Input.TextArea rows={3} placeholder="Optional description" />
        </Form.Item>
      </StyledForm>
    </Modal>
  );
}
